import { dialogRegistry } from '@microsoft/portal-app/lib/Notifications/dialogRegistry';
import * as React from 'react';
import { addReducer } from '../../../redux/modules/root';
import { AccountActions, IAccountAction, IAccountState, IRootAccountState } from '../../models';
import { accountRegistry } from '../../redux';
import { getTelemetry } from '../../../Telemetry/Telemetry';

export const LeaveOrgSuccessDialog = React.lazy(() =>
  import('./LeaveOrgSuccessDialog')
    .then((loaded) => ({
      default: loaded.ConnectedLeaveOrgSuccessDialog,
    }))
    .catch((err) => {
      const telemetry = getTelemetry();
      telemetry.error('resourceError/LeaveOrgSuccessDialog', `Failed to get bundle ${err}`);
      throw err;
    }),
);

dialogRegistry.addDialog({
  component: LeaveOrgSuccessDialog,
  dialogAction: AccountActions.redirectBack,
});

addReducer<IRootAccountState, IAccountState, IAccountAction>('account', accountRegistry);
